import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { NotificationCenterMessageView } from '../notification-center/models/notification-center-message-view.model';
import { NotificationCenterActionType } from '../notification-center/models/notification-center-message.enum';
import { NotificationsCenterMappingStore, NotificationsCenterMappingState } from './notifications-center-mapping.store';

@Injectable({ providedIn: 'root' })
export class NotificationsCenterMappingQuery extends QueryEntity<NotificationsCenterMappingState> {
  constructor(protected store: NotificationsCenterMappingStore) {
    super(store);
  }

  /**
   * Gets the mapping url as a string for use as the link on the notification
   * @param notification Notification we want to get the mapping for
   */
  getMappingFromNotifciation(notification: NotificationCenterMessageView): string {
    let mappingForLoyalty = this.getAll().find((nm) => nm.loyaltyActionId === notification.loyaltyActionId);
    if (!notification) {
      return '';
    }

    switch (notification.actionType) {
      case NotificationCenterActionType.NoAction:
        return '';
      case NotificationCenterActionType.InternalLink:
        return this.getInternalMappingLink(notification);
      case NotificationCenterActionType.ExternalLink:
        return mappingForLoyalty?.actionUrl as string;
    }
  }

  /**
   * Gets the mapping url for the internal mapping, when the actiontype is internal
   * @param notification Notification for the internal mapping
   */
  private getInternalMappingLink(notification: NotificationCenterMessageView): string {
    let mappingForLoyalty = this.getAll().find((nm) => nm.loyaltyActionId === notification.loyaltyActionId);
    if (!mappingForLoyalty || !mappingForLoyalty.mappingExists) {
      return notification.action || '';
    }
    return mappingForLoyalty.actionUrl;
  }
}
